"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelTogglesT = exports.ModelToggles = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * Settings for the skeletal model that are toggles.
 */
class ModelToggles {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsModelToggles(bb, obj) {
        return (obj || new ModelToggles()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsModelToggles(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ModelToggles()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    extendedSpine() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    extendedPelvis() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    extendedKnee() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    forceArmsFromHmd() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    floorClip() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    skatingCorrection() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    toeSnap() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    footPlant() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    selfLocalization() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    usePosition() {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    enforceConstraints() {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    correctConstraints() {
        const offset = this.bb.__offset(this.bb_pos, 28);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    static startModelToggles(builder) {
        builder.startObject(13);
    }
    static addExtendedSpine(builder, extendedSpine) {
        builder.addFieldInt8(0, +extendedSpine, 0);
    }
    static addExtendedPelvis(builder, extendedPelvis) {
        builder.addFieldInt8(1, +extendedPelvis, 0);
    }
    static addExtendedKnee(builder, extendedKnee) {
        builder.addFieldInt8(2, +extendedKnee, 0);
    }
    static addForceArmsFromHmd(builder, forceArmsFromHmd) {
        builder.addFieldInt8(3, +forceArmsFromHmd, 0);
    }
    static addFloorClip(builder, floorClip) {
        builder.addFieldInt8(4, +floorClip, 0);
    }
    static addSkatingCorrection(builder, skatingCorrection) {
        builder.addFieldInt8(5, +skatingCorrection, 0);
    }
    static addToeSnap(builder, toeSnap) {
        builder.addFieldInt8(7, +toeSnap, 0);
    }
    static addFootPlant(builder, footPlant) {
        builder.addFieldInt8(8, +footPlant, 0);
    }
    static addSelfLocalization(builder, selfLocalization) {
        builder.addFieldInt8(9, +selfLocalization, 0);
    }
    static addUsePosition(builder, usePosition) {
        builder.addFieldInt8(10, +usePosition, 0);
    }
    static addEnforceConstraints(builder, enforceConstraints) {
        builder.addFieldInt8(11, +enforceConstraints, 0);
    }
    static addCorrectConstraints(builder, correctConstraints) {
        builder.addFieldInt8(12, +correctConstraints, 0);
    }
    static endModelToggles(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createModelToggles(builder, extendedSpine, extendedPelvis, extendedKnee, forceArmsFromHmd, floorClip, skatingCorrection, toeSnap, footPlant, selfLocalization, usePosition, enforceConstraints, correctConstraints) {
        ModelToggles.startModelToggles(builder);
        if (extendedSpine !== null)
            ModelToggles.addExtendedSpine(builder, extendedSpine);
        if (extendedPelvis !== null)
            ModelToggles.addExtendedPelvis(builder, extendedPelvis);
        if (extendedKnee !== null)
            ModelToggles.addExtendedKnee(builder, extendedKnee);
        if (forceArmsFromHmd !== null)
            ModelToggles.addForceArmsFromHmd(builder, forceArmsFromHmd);
        if (floorClip !== null)
            ModelToggles.addFloorClip(builder, floorClip);
        if (skatingCorrection !== null)
            ModelToggles.addSkatingCorrection(builder, skatingCorrection);
        if (toeSnap !== null)
            ModelToggles.addToeSnap(builder, toeSnap);
        if (footPlant !== null)
            ModelToggles.addFootPlant(builder, footPlant);
        if (selfLocalization !== null)
            ModelToggles.addSelfLocalization(builder, selfLocalization);
        if (usePosition !== null)
            ModelToggles.addUsePosition(builder, usePosition);
        if (enforceConstraints !== null)
            ModelToggles.addEnforceConstraints(builder, enforceConstraints);
        if (correctConstraints !== null)
            ModelToggles.addCorrectConstraints(builder, correctConstraints);
        return ModelToggles.endModelToggles(builder);
    }
    unpack() {
        return new ModelTogglesT(this.extendedSpine(), this.extendedPelvis(), this.extendedKnee(), this.forceArmsFromHmd(), this.floorClip(), this.skatingCorrection(), this.toeSnap(), this.footPlant(), this.selfLocalization(), this.usePosition(), this.enforceConstraints(), this.correctConstraints());
    }
    unpackTo(_o) {
        _o.extendedSpine = this.extendedSpine();
        _o.extendedPelvis = this.extendedPelvis();
        _o.extendedKnee = this.extendedKnee();
        _o.forceArmsFromHmd = this.forceArmsFromHmd();
        _o.floorClip = this.floorClip();
        _o.skatingCorrection = this.skatingCorrection();
        _o.toeSnap = this.toeSnap();
        _o.footPlant = this.footPlant();
        _o.selfLocalization = this.selfLocalization();
        _o.usePosition = this.usePosition();
        _o.enforceConstraints = this.enforceConstraints();
        _o.correctConstraints = this.correctConstraints();
    }
}
exports.ModelToggles = ModelToggles;
class ModelTogglesT {
    constructor(extendedSpine = null, extendedPelvis = null, extendedKnee = null, forceArmsFromHmd = null, floorClip = null, skatingCorrection = null, toeSnap = null, footPlant = null, selfLocalization = null, usePosition = null, enforceConstraints = null, correctConstraints = null) {
        this.extendedSpine = extendedSpine;
        this.extendedPelvis = extendedPelvis;
        this.extendedKnee = extendedKnee;
        this.forceArmsFromHmd = forceArmsFromHmd;
        this.floorClip = floorClip;
        this.skatingCorrection = skatingCorrection;
        this.toeSnap = toeSnap;
        this.footPlant = footPlant;
        this.selfLocalization = selfLocalization;
        this.usePosition = usePosition;
        this.enforceConstraints = enforceConstraints;
        this.correctConstraints = correctConstraints;
    }
    pack(builder) {
        return ModelToggles.createModelToggles(builder, this.extendedSpine, this.extendedPelvis, this.extendedKnee, this.forceArmsFromHmd, this.floorClip, this.skatingCorrection, this.toeSnap, this.footPlant, this.selfLocalization, this.usePosition, this.enforceConstraints, this.correctConstraints);
    }
}
exports.ModelTogglesT = ModelTogglesT;
